const _ = require('underscore');
const async = require('async');
const moment = require('moment');

const Constants = require('client/util/Constants').default;
const renderAlertComponent = require('client/components/Alert/AlertWrapper').default;

// Don't require jQuery if already defined as any registered plugins will be lost!
if (!window.jQuery && !window.$) {
  window.$ = window.jQuery = require('jquery');
}

require('public/js/vendor/jquery-cookie.js');

function getCookieOptions() {
  return window.location.protocol === 'https:' ? { secure: true } : null;
}

module.exports.getCookieOptions = getCookieOptions;

module.exports.setClientTimezoneInCookie = function() {
  var time = new Date();
  $.cookie('timezone_offset_minutes', time.getTimezoneOffset(), getCookieOptions());
}

module.exports.queryString = function (queryString) {
  var query = (queryString || window.location.search).substring(1); // delete ?
  if (!query) {
    return false;
  }
  return _
    .chain(query.split('&'))
    .map(function(params) {
      var p = params.split('=');
      return [p[0], decodeURIComponent(p[1])];
    })
    .object()
    .value();
};

module.exports.getCookieValueByKey = function(key) {
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
}

module.exports.userManagementUIDisableEnable = function(settings){
    if (settings.disableUM){
      $("#settingsNav ul").hide();
    } else {
      $("#settingsNav ul").show();
    }
}

/**
 * @description Get query string parameters with Javascript
 *
 * @see
 * https://www.npmjs.com/package/url-search-params
 * https://davidwalsh.name/query-string-javascript
 */
module.exports.getUrlParameter = function getUrlParameter(name, hash = window.location.hash) {
  const key = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${key}=([^&#]*)`);
  const results = regex.exec(hash);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/**
 * Displays a notification to the user
 * notify(msg)
 * notify(type, msg)
 * notify(type, msg, delay)
 * notify(type, msg, el, delay)
 *
 * @param {string} [type=info] - The alert type (info, error, warning, success)
 * @param {string} msg - The text to be displayed in the alert
 * @param {string} [el] - The container element of the alert
 * @param {number} [delay] - The number of milliseconds before the alert fades
 */
const notify = module.exports.notify = (...args) => {
  let type = 'info';
  let msg = '';
  let el = '#messages';
  let delay = 7000;  // default delay of 7 seconds

  if ($(el).length === 0) return;

  switch (args.length) {
    case 4:
      delay = args[3];
      el = args[2];
      msg = args[1];
      type = args[0];
      break;
    case 3:
      delay = args[2];
    case 2:
      msg = args[1];
      type = args[0];
      break;
    default:
      msg = args[0];
  }

  // attach empty element into DOM for the vue component to replace
  $('<div class="alert-container"></div>').prependTo(el);
  const alert = renderAlertComponent('.alert-container', {
    type,
    text: msg,
  });

  if (delay) {
    window.setTimeout(() => {
      alert.$children[0].hide();
    }, delay);
  }

  return alert;
}


// helper to grab form data from a html partial and return an object
// example: getPayload(body, ['name', 'id'], 'user'); // returns { user: {name: val, id: val}}

module.exports.getPayload = function getPayload(el, selection, ns) {
  var items = {}, obj = {};
  selection.forEach(function (item) {
    var elem = el.find(".input[name=" + item + "]");
    if (elem && $(elem)[0]){
    if ($(elem)[0].type == "checkbox")
      items[item] = elem.prop('checked');
    else
      items[item] = elem.val().trim();
    }
  });
  if (!ns) return items;
  obj[ns] = items;
  return obj;
}

// usage: openTab(window.location.hash);
// the premise is the hashes you generate should not point to a real hash
// pointing to a real hash causes the page to jump
// so prefix with something like "tabdetail-{hash}"

module.exports.openTab = function openTab(id) {
  var id = id.replace(/^#.*-/, '#')
    , el = $(id);
  if (!el.length) return;

  var tabgroup = el.parents('.tabbable');

  tabgroup.find("ul.nav-tabs li").each(function () {
    var el = $(this)
      , link = el.find('a');
    if (link.attr('href') == id) el.addClass('active')
    else el.removeClass('active');
  });

  tabgroup.find('.tab-content .tab-pane').removeClass('active')
  el.addClass('active');
}


module.exports.CheckBoxToggler = CheckBoxToggler;

function CheckBoxToggler(){

  this.buttons = [];
  this.box = undefined;
};


CheckBoxToggler.prototype = {

  registerButton: function(id, activeClass, inactiveClass){

    this.buttons.push({id: id, activeClass: activeClass, inactiveClass: inactiveClass})

  },

  registerBox: function(clazz){

    var self = this;
    this.box = clazz

    var onClick = $.proxy(self.handleClick, self)

    $('.' + this.box).click(onClick)

  },

  handleClick: function(){

    var checked = $("." + this.box+ ":checkbox:checked").length;
    var appliedClass = "inactiveClass"
    var removedClass = "activeClass";
    if(checked > 0){
      appliedClass = "activeClass";
      removedClass = "inactiveClass";
    }

    this.buttons.forEach(function(item){

      $('#' + item.id).removeClass(item[removedClass]).addClass(item[appliedClass]);

    })


  }
};

module.exports.uuid = function uuid(){
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (d + Math.random()*16)%16 | 0;
    d = Math.floor(d/16);
    return (c=='x' ? r : (r&0x7|0x8)).toString(16);
  });
  return uuid;
};

/**
 * Formats a javascript array as a human-readable series. Use a wrapper function to
 * get something a little more fancy.
 *
 * Basic Example:
 *   ['a', 'b', 'c'] => 'a, b, and c'
 *
 * Wrapper Example:
 *   ['a', 'b', 'c'], function (item) { return '<strong>' + item + '</strong>'; } =>
 *     '<strong>a</strong>, <strong>b</strong>, and <strong>c</strong>'.
 */
module.exports.formatListAsSeries = function (list, wrapperFunc) {

  // Make sure we have a wrapper function if one isn't provided...
  if (!wrapperFunc || typeof wrapperFunc !== 'function') {
    wrapperFunc = function (item) { return item; };
  }

  // Make sure we have a proper list...
  if (!list || Object.prototype.toString.call(list) !== '[object Array]') {
    return wrapperFunc('');
  }

  // Scrub list for any empty / nonstring elements...
  var cleanList = [];
  for (var item in list) {
    if (typeof list[item] === 'string' && list[item].replace(/^\s+|\s+$/g, '').length > 0) {
     cleanList.push(list[item]);
    }
  }
  list = cleanList;

  // Sort the items alphabetically (ignoring case)...
  list.sort(function (a, b) {
    return a.toLowerCase().localeCompare(b.toLowerCase());
  });

  // Handle different list cases...
  if (list.length == 0) {
    return wrapperFunc('');
  }
  else if (list.length == 1) {
    return wrapperFunc(list[0]);
  }
  else if (list.length == 2) {
    return wrapperFunc(list[0]) + ' and ' + wrapperFunc(list[1]);
  }
  else {
    var series = '';
    for (var i = 0; i < list.length; i++) {
      if (i == list.length - 1) {
        series += 'and ' + wrapperFunc(list[i]);
      }
      else {
        series += wrapperFunc(list[i]) + ', ';
      }
    }
    return series;
  }
};

module.exports.ga = (...params) => {
  if (window.ga && typeof window.ga === 'function') {
    return window.ga(...params);
  }
};
